import './Dropdown.css'

import React, { useState, useEffect, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

function App(props) {
  let [isOpen, setIsOpen] = useState(false)
  
  return (
    <Navbar isDropDownOpen={setIsOpen}>
      <NavItem count={props.count}isOpen={isOpen} icon={<span class="material-symbols-outlined" style={{color:' #484a4d', marginInlineStart:'5rem'}}
      isDropDownOpen={setIsOpen}>settings</span>}>
        <DropdownMenu 
        {...props && props}
        isDropDownOpen={setIsOpen}>
        </DropdownMenu>
      </NavItem>
    </Navbar>
  );
}

function Navbar(props) {
  return (
    <nav className="dashboard-navbar">
      <ul className="dashboardnavbar-nav">{props.children}</ul>
    </nav>
  );
}

function NavItem(props) {
  return (
    <li className="nav-item">
      <a   style={{color:'#ffff'}} onClick={() => props.children.props.isDropDownOpen(!props.isOpen)}>{props.icon}
      </a>
      { props.isOpen && props.children}
    </li>
  );
}

function DropdownMenu(props) {


  const [activeMenu, setActiveMenu] = useState('settings');
  const [menuHeight, setMenuHeight] = useState(null);



  const[selectedTab, setSeletctedTab] = useState(null)
  const dropdowncardRef = useRef(null);



  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdowncardRef.current && !dropdowncardRef.current.contains(event.target)) {
        props.isDropDownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  },[dropdowncardRef])



  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function DropdownItem(props) {
    const [testText, setTestText] = useState("")
    

    return (
      <a className="menu-item" onClick={(e) => {
        if(e.target.textContent !== undefined && e.currentTarget.textContent.indexOf(' ') > 0){
          if (props.title == "Production") {
            props && props.setGetProductionCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallProductionCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == "Dispatch") {
            props && props.setGetDispatchCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallDispatchCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == 'Inward') {
            props && props.setGetInwardCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallgetInwardCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
          else if (props.title == 'Inventory') {
            props && props.setGetInventoryCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props && props.setallgetInventoryCharts(`${props.title + e.target.textContent.split(/(?=[A-Z])/)[1].trim()}`)
            props.isDropDownOpen(false)
          }
        }
       setActiveMenu('settings')
      }}>
        <span className="icon-button" style={{color:'#ffff'}}>{props.leftIcon}</span>
        {props.children}
        <span className="icon-right" style={{color:'black'}}>{props.rightIcon}</span>
      </a>
    );
  }


  return (
    <div className="dropdowncard" style={{ height: menuHeight }} ref={dropdowncardRef}>

      <CSSTransition
        in={activeMenu === 'settings'}
        timeout={500}
        classNames="menu-secondary"
        unmountOnExit
        onEnter={calcHeight}>
        <div className="menu">
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}   leftIcon={<span class="material-symbols-outlined">bar_chart</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Bar Chart</DropdownItem>
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}  leftIcon={<span class="material-symbols-outlined">pie_chart</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Pie Chart</DropdownItem>
          <DropdownItem
           setallgetInwardCharts={props.setallgetInwardCharts}
           setallDispatchCharts={props.setallDispatchCharts}
           setallProductionCharts={props.setallProductionCharts}
           setallgetInventoryCharts={props.setallgetInventoryCharts}
           setGetProductionCharts={props.setGetProductionCharts} setGetInventoryCharts={props.setGetInventoryCharts} setGetDispatchCharts={props.setGetDispatchCharts} setGetInwardCharts={props.setGetInwardCharts}  title={props.title}  leftIcon={<span class="material-symbols-outlined">donut_small</span>} setSelectedCardTitle={props.setSelectedCardTitle}
           isDropDownOpen={props.isDropDownOpen}
           >Doughnut Chart</DropdownItem>
          <br></br>
        </div>
      </CSSTransition>
    </div>
  );
}

export default App;